var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgBuildings = function SvgBuildings(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129 140H12L35.1 20H152L129 140Z",
    fill: "#E6E6F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132 123.5H15L14 129.5H131L132 123.5Z",
    fill: "#9FA4D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 122.5C8 121.7 8.7 121 9.5 121H136.5C137.3 121 138 121.7 138 122.5C138 123.3 137.3 124 136.5 124H9.5C8.7 124 8 123.3 8 122.5Z",
    fill: "#313E48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5002 56.3C21.5002 56.3 20.3002 41.6 34.8002 37.7C47.1002 34.4 53.9002 45.5 53.9002 45.5C53.9002 45.5 59.7002 39.7 67.8002 43.7C77.2002 48.4 75.5002 56.3 75.5002 56.3C75.5002 56.3 82.9002 58.7 83.2002 66.6C83.4002 72.8 79.7002 79.4 67.6002 79.9C53.4002 80.5 33.7002 80.1 24.3002 79.9C10.8002 79.6 6.40024 62.8 21.5002 56.3Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3002 81.7C39.3002 81.7 29.6002 81.5 24.3002 81.4C17.4002 81.2 11.9002 77 10.7002 70.9C9.30024 63.4 14.6002 58 20.0002 55.3C20.1002 51.6 21.3002 39.7 34.4002 36.2C44.9002 33.4 51.7002 40.2 54.2002 43.3C57.1002 41.3 62.4002 39.3 68.5002 42.3C73.8002 45 75.9002 48.7 76.7002 51.3C77.2002 52.9 77.2002 54.3 77.2002 55.3C79.5002 56.4 84.5002 59.6 84.8002 66.5C84.9002 69.8 84.0002 80.7 67.8002 81.4C62.0002 81.6 55.6002 81.7 49.3002 81.7ZM39.3002 38.6C38.0002 38.6 36.6002 38.8 35.2002 39.2C22.1002 42.7 23.0002 55.7 23.0002 56.2L23.1002 57.3L22.1002 57.7C14.7002 60.9 12.9002 66.3 13.7002 70.3C14.5002 74.2 18.1002 78.3 24.4002 78.4C33.0002 78.6 53.2002 79 67.6002 78.4C80.7002 77.9 81.9002 70 81.8002 66.6C81.5002 59.9 75.4002 57.8 75.1002 57.7L73.8002 57.3L74.0002 56C74.1002 55.7 75.3002 49.1 67.1002 45.1C60.1002 41.6 55.1002 46.4 54.9002 46.6L53.6002 47.9L52.6002 46.3C52.4002 45.9 47.7002 38.6 39.3002 38.6Z",
    fill: "#313E48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0005 54.5C28.0005 54.5 27.7005 46.9 35.7005 44.3C41.5005 42.5 46.1005 47.1 46.1005 47.1",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0002 56C27.2002 56 26.5002 55.4 26.5002 54.6C26.4002 51.6 28.1002 45.2 35.2002 42.9C41.8002 40.9 46.9002 45.9 47.1002 46.1C47.7002 46.7 47.7002 47.6 47.1002 48.2C46.5002 48.8 45.6002 48.8 45.0002 48.2C44.8002 48 40.9002 44.3 36.1002 45.8C29.3002 48 29.4002 54.3 29.5002 54.5C29.5002 55.3 28.9002 56 28.0002 56Z",
    fill: "#313E48"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8996 92H19.0996V122.6H48.8996V92Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3996 124.1H17.5996V90.5H50.3996V124.1ZM20.5996 121.1H47.3996V93.5H20.5996V121.1Z",
    fill: "#313E48"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M129 53.2L91.9002 34.9C90.6002 34.3 89.2002 35.2 89.2002 36.6V122.6H129.1L129 53.2Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M130.6 124.1H87.7002V36.6C87.7002 35.4 88.3002 34.4 89.2002 33.7C90.2002 33.1 91.4002 33 92.5002 33.5L129.3 51.7H130.5V124.1H130.6ZM90.7002 121.1H127.6V54.2L91.2002 36.2C91.0002 36.1 90.9002 36.2 90.8002 36.2C90.7002 36.2 90.6002 36.3 90.6002 36.5V121.1H90.7002Z",
    fill: "#313E48"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3996 110.6H29.0996V121.6H38.3996V110.6Z",
    fill: "#94C1AE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8996 123.1H27.5996V109.1H39.8996V123.1ZM30.5996 120.1H36.8996V112.1H30.5996V120.1Z",
    fill: "#313E48"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8004 88.2H18.9004V98.4H48.8004V88.2Z",
    fill: "#EADB9E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3004 99.9H17.4004V86.7H50.3004V99.9ZM20.4004 96.9H47.3004V89.7H20.4004V96.9Z",
    fill: "#313E48"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105.9 56.3H97.4004V65.4H105.9V56.3Z",
    fill: "#94C1AE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M107.4 66.9H95.9004V54.8H107.4V66.9ZM98.9004 63.9H104.4V57.8H98.9004V63.9Z",
    fill: "#313E48"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M120.8 72.2H112.3V81.3H120.8V72.2Z",
    fill: "#EADB9E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M122.3 82.8H110.8V70.7H122.3V82.8ZM113.8 79.8H119.3V73.7H113.8V79.8Z",
    fill: "#313E48"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M107.3 87.6H98.7998V96.7H107.3V87.6Z",
    fill: "#9FA4D0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M108.8 98.2H97.2998V86.1H108.8V98.2ZM100.3 95.2H105.8V89.1H100.3V95.2Z",
    fill: "#313E48"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 49.2C117.7 49.2 117 48.5 117 47.7V32.6C117 31.8 117.7 31.1 118.5 31.1C119.3 31.1 120 31.8 120 32.6V47.7C120 48.5 119.3 49.2 118.5 49.2Z",
    fill: "#313E48"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M122.5 105.7H112.3V121.9H122.5V105.7Z",
    fill: "#5FA8DC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M124 123.4H110.8V104.2H124V123.4ZM113.8 120.4H121V107.2H113.8V120.4Z",
    fill: "#313E48"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40.7C77.2 40.7 76.5 40 76.5 39.2V33.6C76.5 32.8 77.2 32.1 78 32.1C78.8 32.1 79.5 32.8 79.5 33.6V39.2C79.5 40 78.8 40.7 78 40.7Z",
    fill: "#313E48"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9998 37.8H74.7998C73.9998 37.8 73.2998 37.1 73.2998 36.3C73.2998 35.5 73.9998 34.8 74.7998 34.8H80.9998C81.7998 34.8 82.4998 35.5 82.4998 36.3C82.4998 37.1 81.7998 37.8 80.9998 37.8Z",
    fill: "#313E48"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2002 29.1C86.4002 29.1 85.7002 28.4 85.7002 27.6V22C85.7002 21.2 86.4002 20.5 87.2002 20.5C88.0002 20.5 88.7002 21.2 88.7002 22V27.6C88.7002 28.4 88.0002 29.1 87.2002 29.1Z",
    fill: "#313E48"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2996 26.2H84.0996C83.2996 26.2 82.5996 25.5 82.5996 24.7C82.5996 23.9 83.2996 23.2 84.0996 23.2H90.2996C91.0996 23.2 91.7996 23.9 91.7996 24.7C91.7996 25.5 91.0996 26.2 90.2996 26.2Z",
    fill: "#313E48"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3002 71.4C47.7002 71.8 34.4002 71.5 28.0002 71.4C21.9002 71.3 18.6002 65.7 20.3002 60.7C11.5002 65.7 14.6002 76.7 23.2002 76.9C29.6002 77 42.9002 77.3 52.5002 76.9C58.9002 76.6 61.9002 73.7 62.8002 70.3C61.3002 70.9 59.5002 71.3 57.3002 71.4Z",
    fill: "#D8E8F6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9996 64.4C60.9996 64.4 54.5996 70.8 54.5996 78.8V122.6H83.3996V78.8C83.3996 70.8 76.9996 64.4 68.9996 64.4Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8996 124.1H53.0996V78.8C53.0996 70 60.1996 62.9 68.9996 62.9C77.7996 62.9 84.8996 70 84.8996 78.8V124.1ZM56.0996 121.1H81.8996V78.8C81.8996 71.7 76.0996 65.9 68.9996 65.9C61.8996 65.9 56.0996 71.7 56.0996 78.8V121.1Z",
    fill: "#313E48"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4002 105.7H64.2002V121.9H74.4002V105.7Z",
    fill: "#9FA4D0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9002 123.4H62.7002V104.2H75.9002V123.4ZM65.7002 120.4H72.9002V107.2H65.7002V120.4Z",
    fill: "#313E48"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3996 82.6H71.5996C70.7996 82.6 70.0996 81.9 70.0996 81.1C70.0996 80.3 70.7996 79.6 71.5996 79.6H83.3996C84.1996 79.6 84.8996 80.3 84.8996 81.1C84.8996 81.9 84.1996 82.6 83.3996 82.6Z",
    fill: "#313E48"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4998 89.9H66.2998C65.4998 89.9 64.7998 89.2 64.7998 88.4C64.7998 87.6 65.4998 86.9 66.2998 86.9H82.4998C83.2998 86.9 83.9998 87.6 83.9998 88.4C83.9998 89.2 83.2998 89.9 82.4998 89.9Z",
    fill: "#313E48"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7998 96.7H76.7998C75.9998 96.7 75.2998 96 75.2998 95.2C75.2998 94.4 75.9998 93.7 76.7998 93.7H82.7998C83.5998 93.7 84.2998 94.4 84.2998 95.2C84.2998 96 83.5998 96.7 82.7998 96.7Z",
    fill: "#313E48"
  })));
};
export { SvgBuildings as ReactComponent };
export default __webpack_public_path__ + "static/media/buildings.bb6085f6.svg";